const hostBack = 'https://us-central1-allportal-ee7c5.cloudfunctions.net/app/';

export const environment = {
  production: false,
  useEmulators: false,
  login: `${hostBack}auth/login`,
  logout: `${hostBack}auth/logout`,
  createUser: `${hostBack}users/new-user`,
  getUsers: `${hostBack}users/get-all`,
};
